import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import type { ContactUsButtonInterface } from 'common/types/entities/contact-us-button-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import type { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export const createContactUsButton = (
  parentId: string,
  text: string,
  masterBlockId?: MasterBlockIdType,
): ContactUsButtonInterface => ({
  ...generateBaseEntity(
    EntityTypeEnum.ContactUsButton,
    parentId,
    masterBlockId,
  ),
  textFontSize: 20,
  subTextFontSize: 14,
  textColor: 'rgba(255, 255, 255, 1)',
  background: 'rgba(1, 160, 255, 1)',
  alignSelf: 'center',
  text,
  border: {
    radius: 5,
    style: BorderStyleEnum.none,
  },
  padding: {
    paddingTop: 15,
    paddingRight: 90,
    paddingBottom: 15,
    paddingLeft: 90,
  },
})
